import { useTranslation } from '@crehana/i18n';
import { ATS_PUBLIC_CANDIDATE_FORM } from './constants';

export const useTranslationPublicCandidateForm = () => {
  return useTranslation(ATS_PUBLIC_CANDIDATE_FORM);
};
